

const food_subredddits_set = new Set(["cooking","cookingforbeginners","mealprepsunday","eatcheapandhealthy","cheap_meals","slowcooking","askculinary","fromscratch","culinaryplating","wewantplates",
"shittyfoodporn","foodporn","cookie","food","foodscience","food2","restaurant","tacos","todayiate",
"oamc","friedfood","greasyfood","breakfast","sandwiches","spicy","snacks","sushi","dessertporn","veg","veganrecipes","appetizers","raw","redditcookbook","grilling","cookmesomething","baking",
"glutenfree","japanesefood","meat","pasta","fitmeals","cheapmeals"]);

export default food_subredddits_set;